import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import { Row, Col, Table, ListHeader, Button, Spinner, CreditsTableHeader, useUser, useUrlParams, useWindowSize } from 'components';
import { showApiError } from 'utils';
import { getAllCredits, exportAllCredits } from 'services';
import { tableWrap } from 'styles';
import { creditListColumns, creditCardRenderer } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";
var CARD_BREAKPOINT = 1200;

var CreditsList = function CreditsList() {
  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData,
      userInfo = _useUser.userInfo;

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var tableRef = useRef();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var isMobile = windowWidth < CARD_BREAKPOINT;

  var fetchAllCredits = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getAllCredits, _yield$getAllCredits2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return getAllCredits(tableOptions);

            case 3:
              _yield$getAllCredits = _context.sent;
              _yield$getAllCredits2 = _slicedToArray(_yield$getAllCredits, 2);
              res = _yield$getAllCredits2[0];
              err = _yield$getAllCredits2[1];
              setLoading(false);

              if (!err) {
                _context.next = 11;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 11:
              return _context.abrupt("return", [res, null]);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAllCredits(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleExportToExcel = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$exportAllCredi, _yield$exportAllCredi2, res, err, url;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return exportAllCredits(_objectSpread({}, urlQueryParams));

            case 2:
              _yield$exportAllCredi = _context2.sent;
              _yield$exportAllCredi2 = _slicedToArray(_yield$exportAllCredi, 2);
              res = _yield$exportAllCredi2[0];
              err = _yield$exportAllCredi2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(res);
              window.open(url, '_blank', 'noreferrer', 'noopener');

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleExportToExcel() {
      return _ref2.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u041A\u0440\u0435\u0434\u0438\u0442\u0438",
    actions: ___EmotionJSX(Row, {
      horizontalGap: 8
    }, (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.canIssueCredits) && ___EmotionJSX(Col, {
      sm: "auto"
    }, ___EmotionJSX(Button, {
      small: true,
      type: "primary",
      linkTo: "/credits/new",
      leftIcon: {
        iconName: 'la la-plus',
        size: 20
      }
    }, "\u0421\u044A\u0437\u0434\u0430\u0439 \u043A\u0440\u0435\u0434\u0438\u0442")), ___EmotionJSX(Col, {
      sm: "auto"
    }, ___EmotionJSX(Button, {
      small: true,
      type: "secondary",
      onClick: handleExportToExcel,
      leftIcon: {
        iconName: 'la la-file-excel',
        size: 20
      }
    })))
  }), ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Spinner, {
    loading: loading
  }), ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchAllCredits,
    columns: isMobile ? [] : creditListColumns(roleAdditionalData, userInfo),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: CreditsTableHeader,
    margin: "0 2em",
    pageSize: 20,
    renderRow: isMobile ? creditCardRenderer(roleAdditionalData, userInfo) : undefined
  })));
};

export default CreditsList;